// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity-mini[data-v-01698632]{grid-template-columns:50px minmax(auto,400px) auto 1fr 65px minmax(0,auto)!important}.item_instance_sub_type[data-v-01698632]{text-align:center}.item_instance_sub_type .item_class_value[data-v-01698632]{font-size:1.2em}", ""]);
// Exports
module.exports = exports;
